// extracted by mini-css-extract-plugin
export var addressFields = "_mn-0";
export var animationContainer = "_mn-1";
export var footer = "_mn-2";
export var lineItems = "_mn-3";
export var modalContent = "_mn-4";
export var orderName = "_mn-5";
export var strong = "_mn-6";
export var warning = "_mn-7";